import Page from 'modules/Page';
import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project-admin/ProjectsPage/constants';
import { toTitleCase } from 'utils';
import * as constants from './constants';
import { EditBinderCostSettingsPageParams } from './constants';
import useEditBinderSettingsQueries, { EditBinderCostSettingsQueries } from './useEditBinderCostSettingsQueries';

const EditBinderCostSettingsPage = lazyWithSuspense(() => import('./EditBinderCostSettingsPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<EditBinderCostSettingsPageParams, EditBinderCostSettingsQueries>({
    WrappedPage: EditBinderCostSettingsPage,
    titleFn: ([project]) => (project.data ? i18n._('Edit').concat(`${toTitleCase(project.data.name)}`).concat('Binder Settings') : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditBinderSettingsQueries,
  }),
};

export default page;
